import { render, staticRenderFns } from "./fenxi.vue?vue&type=template&id=049841e4&scoped=true&"
import script from "./fenxi.vue?vue&type=script&lang=js&"
export * from "./fenxi.vue?vue&type=script&lang=js&"
import style0 from "./fenxi.vue?vue&type=style&index=0&id=049841e4&prod&lang=scss&"
import style1 from "./fenxi.vue?vue&type=style&index=1&id=049841e4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "049841e4",
  null
  
)

export default component.exports